import { render, staticRenderFns } from "./ClientCommissions.vue?vue&type=template&id=136394f6&scoped=true"
import script from "./ClientCommissions.vue?vue&type=script&lang=js"
export * from "./ClientCommissions.vue?vue&type=script&lang=js"
import style0 from "./ClientCommissions.vue?vue&type=style&index=0&id=136394f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136394f6",
  null
  
)

export default component.exports